import * as React from 'react';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Buttons } from 'rcd-cpp-ui/ui/button/Buttons';
import { Cancel, Primary } from 'rcd-cpp-ui/ui/button';
import { useAlert } from '../Alert/alert';
import { useLoader } from '../Loader/loader';
import { Metadata } from '../../types';
import { Group } from 'rcd-cpp-ui/ui/form';
import { RetirementProps } from '../../types/RetirementProps';

type Props = {
  data: Partial<Metadata>;
  onCancel: () => void;
  onSubmit: (props: RetirementProps) => Promise<any>;
};

const Other = 'Other';

const Reasons = [
  'Lack of analyst resources',
  'Shift in market scope',
  'Shift in market maturity',
  'Low client interest',
  Other
];

const MarketCoverage = [
  'Content transitioning from a MQ to a MG',
  'Content transitioning from a MQ to multiple MQs (change in market scope)',
  'Content transitioning from multiple regional MQs to 1 global MQ',
  Other
];

const getValue = (r: string, txt: string) => {
  if (r && r != Other) return r;
  if (r == Other && txt?.trim()) return txt;
  return null;
};

const isFilled = (r: string, txt: string) => getValue(r, txt) != null;

export const RetireModal = ({ data, onCancel, ...props }: Props) => {
  const [reason, setReason] = React.useState<string>('');
  const [market, setMarket] = React.useState<string>('');
  const [reasonText, setReasonText] = React.useState<string>('');
  const [marketText, setMarketText] = React.useState<string>('');
  React.useEffect(() => {
    if (reason != Other && !!reasonText) setReasonText('');
    if (market != Other && !!marketText) setMarketText('');
  }, [reason, market]);
  const { onSubmit, Loader, Alert } = useLoader(
    useAlert({ onSubmit: props.onSubmit })
  );
  if (!data) return null;
  return (
    <Modal
      id="retireModal"
      header="Retire"
      onClose={onCancel}
      footer={
        <Buttons>
          <Cancel onClick={onCancel} />
          <Primary
            label="Submit"
            onClick={() =>
              onSubmit({
                retirementReason: getValue(reason, reasonText),
                retirementMarketCoverage: getValue(market, marketText)
              })
            }
            disabled={
              !isFilled(reason, reasonText) || !isFilled(market, marketText)
            }
          />
        </Buttons>
      }
    >
      <div className="metadata-form">
        <Loader />
        <Alert />
        <Group label="Select Reason for Retirement" isRequired>
          <select
            className="form-control"
            onChange={e => setReason(e.target.value)}
          >
            {!reason && <option value=""></option>}
            {Reasons.map(r => (
              <option key={r} value={r} selected={reason == r}>
                {r}
              </option>
            ))}
          </select>
        </Group>
        {reason == Other && (
          <Group label="Please specify" isRequired>
            <input
              type="text"
              className="form-control"
              onChange={e => setReasonText(e.target.value)}
              value={reasonText}
            />
          </Group>
        )}
        <Group label="How will the Market be covered?" isRequired>
          <select
            className="form-control"
            onChange={e => setMarket(e.target.value)}
          >
            {!market && <option value=""></option>}
            {MarketCoverage.map(r => (
              <option key={r} value={r} selected={market == r}>
                {r}
              </option>
            ))}
          </select>
        </Group>
        {market == Other && (
          <Group label="Please specify" isRequired>
            <input
              type="text"
              className="form-control"
              onChange={e => setMarketText(e.target.value)}
              value={marketText}
            />
          </Group>
        )}
      </div>
    </Modal>
  );
};
